import { action, computed, makeObservable, observable, toJS } from "mobx";
import fetchData from "../utils/fetchData";
import { getFormDataUrl } from "../utils/helpers";

export default class FormStore {
  // initial values
  fieldsRaw = [];
  formsRaw = {};
  dataRaw = [];
  formExistsRaw = false;
  approvalFieldsRaw = [];
  logRaw = [];
  energyDataByYear = [];
isLoading = false;

  // store constructor
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      //values
      fieldsRaw: observable,
      formsRaw: observable,
      dataRaw: observable,
      formExistsRaw: observable,
      approvalFieldsRaw: observable,
      energyDataByYear: observable,
      isLoading: observable,
      //computed
      fields: computed,
      forms: computed,
      data: computed,
      approvalFields: computed,
      //actions
      fetchFields: action.bound,
      fetchForms: action.bound,
      reset: action.bound,
      create: action.bound,
      getFormData: action.bound,
      createBasicForm: action.bound,
      recordExists: action.bound,
      setFormExists: action.bound,
      fetchApprovalFields: action.bound,
      updateFields: action.bound,
      approveForm: action.bound,
      deleteForm: action.bound,
      logData: action.bound,
      logRaw: observable,
      fetchEnergyByYear: action.bound,
    });
  }

  // computed values
  get fields() {
    return toJS(this.fieldsRaw);
  }

  get log() {
    return toJS(this.logRaw);
  }

  get forms() {
    return toJS(this.formsRaw);
  }

  get data() {
    return toJS(this.dataRaw);
  }

  get formExists() {
    return toJS(this.formExistsRaw);
  }

  get approvalFields() {
    return toJS(this.approvalFieldsRaw);
  }

  // reset function
  reset() {
    this.fieldsRaw = [];
    this.formsRaw = {};
    this.formExistsRaw = false;
    this.approvalFieldsRaw = [];
    this.logRaw = [];
  }
}

// actions

//only for exceldownload
FormStore.prototype.fetchFieldsForExcel = async (catId, subCatId, kpiId) => {
  try {
    const body = JSON.stringify({ catId, subCatId, kpiId });

    const response = await fetchData(`company/getAssignedFields`, {
      method: "POST",
      body,
    });

    const result = await response.json();

    if (result.status && Array.isArray(result.data)) {
      return result.data; // ✅ RETURN directly
    }

    return [];
  } catch (error) {
    console.error("Error in fetchFieldsForExcel:", error);
    return [];
  }
};



FormStore.prototype.fetchFields = function () {
  const { catId, subCatId, kpiId } = this.rootStore.companyStore;
  const body = JSON.stringify({
    catId,
    subCatId,
    kpiId,
  });
  fetchData(`company/getAssignedFields`, {
    method: "POST",
    body,
  })
    .then((response) => response.json())
    .then((result) => {
      if (result.status) {
        this.fieldsRaw = result.data;
      }
    })
    .catch((error) => console.error("Eroooroorororoor", error));
};

FormStore.prototype.create = function ({
  payload,
  groupPayload,
  update,
  formId,
  showAlert,
  endpoint,
  setEditForm,
  navigate,
  totalGroups,
  frequency,
  groupData,
  pageUrl,
  redirectUrl,
  globalUnit,
  group,
  filled,
}) {
  const token = JSON.parse(
    localStorage.getItem("access-token") ||
      localStorage.getItem("admin-access-token")
  )?.token;
  const formData = new FormData();
  
  // Clean payloads to ensure no NaN values
  const cleanPayload = (data) => {
    try {
      console.log("🔍 Cleaning payload data:", data);
      return JSON.parse(JSON.stringify(data, (key, value) => {
        if (typeof value === 'number') {
          if (isNaN(value) || !isFinite(value)) {
            console.warn(`⚠️ Found invalid number for key "${key}":`, value, "-> converting to 0");
            return 0;
          }
        }
        if (typeof value === 'string' && (value.toLowerCase() === 'nan' || value === 'Infinity' || value === '-Infinity')) {
          console.warn(`⚠️ Found invalid string for key "${key}":`, value, "-> converting to '0'");
          return "0";
        }
        return value;
      }));
    } catch (error) {
      console.error("❌ Error during payload cleaning:", error);
      console.error("Original data that caused error:", data);
      throw error;
    }
  };

  let cleanedPayload, cleanedGroupPayload;
  
  try {
    cleanedPayload = cleanPayload(payload);
    cleanedGroupPayload = cleanPayload(groupPayload);
    
    console.log("✅ Cleaned payload:", cleanedPayload);
    console.log("✅ Cleaned group payload:", cleanedGroupPayload);
    
    formData.append("data", JSON.stringify(cleanedPayload));
    formData.append("groupPayload", JSON.stringify(cleanedGroupPayload));
  } catch (payloadError) {
    console.error("❌ PAYLOAD PREPARATION ERROR:", payloadError);
    console.error("Original payload:", payload);
    console.error("Original groupPayload:", groupPayload);
    showAlert("Error preparing data for submission: " + payloadError.message);
    return;
  } 
  cleanedPayload.forEach((pay, index) => {
    if (pay?.attachment?.length) {
      for (let i = 0; i < pay.attachment.length; i++) {
        formData.append(`file[]`, pay.attachment[i]);
        formData.append(`index[]`, pay.fieldId || index);
      }
    }
  });
  fetch(
    process.env.REACT_APP_BASE_URL +
      `${endpoint}/${update ? "update" : "create"}${
        formId ? `?formId=${formId}` : ""
      }`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then(async (res) => {
      if (!res.ok) {
        console.error("❌ HTTP Error:", res.status, res.statusText);
        
        // Try to get more detailed error information from the response
        try {
          const errorText = await res.text();
          console.error("Error response body:", errorText);
          
          // Try to parse as JSON if possible
          try {
            const errorJson = JSON.parse(errorText);
            console.error("Parsed error JSON:", errorJson);
            
            if (errorJson.message) {
              showAlert(`Server Error (${res.status}): ${errorJson.message}`);
            } else {
              showAlert(`Server Error (${res.status}): ${errorText}`);
            }
          } catch (parseError) {
            showAlert(`Server Error (${res.status}): ${errorText}`);
          }
        } catch (textError) {
          console.error("Could not read error response:", textError);
          showAlert(`Server Error (${res.status}): ${res.statusText}`);
        }
        return null;
      }
      
      return res.json();
    })
    .then((response) => {
      if (!response) return; // Handle case where response is null due to error
      
      if (response.status) {
        showAlert(response.message, true);
        if (update) {
          setEditForm("");
        }
        const groupsFilled =
          endpoint === "add-water"
            ? [...(filled || []), ...(update ? [] : [group])]
            : response.data.groupsFilled;
        if (groupsFilled.length === totalGroups) {
          navigate(redirectUrl);
          return;
        }
        navigate(pageUrl, {
          state: {
            freq: frequency,
            formid: response.data.formId,
            groupsFilled,
            formData: groupData,
            unitGlobal: globalUnit,
          },
        });
        return;
      }
      
      // Log the full response for debugging when status is false
      console.error("API returned error response:", response);
      showAlert(response.message || "Unknown server error");
    })
    .catch((err) => {
      console.error("=== EMISSION API ERROR ===");
      console.error("Error:", err);
      console.error("Error message:", err.message);
      console.error("Error stack:", err.stack);
      console.error("========================");
      showAlert("Network/Server error: " + err.message);
    });
};

FormStore.prototype.getFormData = function ({
  signal,
  type,
  formId,
  showAlert,
}) {
  fetchData(`${getFormDataUrl(type)}?formId=${formId}`, {
    method: "POST",
    signal,
  })
    .then((res) => res.json())
    .then((data) => {
      
      if (data.status) {
        this.dataRaw = data.data;
        return;
      }
      showAlert?.(data.message);
    })
    .catch((err) => {
      showAlert?.(err.message);
      console.error(err);
    });
};

FormStore.prototype.createBasicForm = function ({
  data,
  fullData,
  companyUnit,
  year,
  showAlert,
  navigate,
  formId,
  update,
  setEditForm,
}) {
  const payload = data?.values?.map((ele) => ({
    fieldId: ele.fieldId,
    fieldName: ele.fieldName,
    group: ele.group,
    value: ele.value,
    companyUnit,
    year,
  }));
  const file = data.file;
  const token = JSON.parse(
    localStorage.getItem("access-token") ||
      localStorage.getItem("admin-access-token")
  )?.token;
  const formData = new FormData();
  formData.append("payload", JSON.stringify(payload));
  if (file?.length) {
    for (let i = 0; i < file.length; i++) {
      formData.append(`file[]`, file[i]);
    }
  }  formData.append("group", data.group);
  fetch(
    process.env.REACT_APP_BASE_URL +
      `basic/${update ? "update" : "create"}${
        formId ? `?formId=${formId}` : ""
      }`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => res.json())
    .then((result) => {
      showAlert(result.message, result.status);
      if (result.status) {
        setEditForm?.("");
        if (result?.data?.groupsFilled?.length === 9) {
          navigate("/company/basic_parameter");
          return;
        }
        navigate("/company/basic_parameter", {
          state: {
            formData: fullData,
            formYear: year,
            groupsFilled: result.data.groupsFilled,
            formid: result.data.formId,
          },
        });
      }
    })
    .catch((err) => {
      showAlert(err.message);
      console.error(err);
    });
};

FormStore.prototype.recordExists = function ({ frequency, type }) {
  const { companyStore: { companyUnit } } = this.rootStore;
  const urlParams = new URLSearchParams({ ...frequency, type, companyUnit });
  
  fetchData(`form/exists?${urlParams.toString()}`)
    .then((res) => res.json())
    .then((result) => {
      this.formExistsRaw = result.data;
    })
    .catch((error) => {
      console.error("❌ FormStore - Error checking record exists:", error);
    });
};

FormStore.prototype.setFormExists = function (payload = false) {
  this.formExistsRaw = payload;
};

FormStore.prototype.fetchForms = function ({ type, page, pageSize, filter }) {
  const body = JSON.stringify(filter);
  const params = new URLSearchParams({ type, page, pageSize });
  fetchData(`form/list?${params.toString()}`, {
    method: "POST",
    body,
  })
    .then((res) => res.json())
    .then((res) => {
    
      this.formsRaw = res.data;
    })
    .catch((err) => {
      console.error("[Error]", err);
    });
};

FormStore.prototype.fetchApprovalFields = function ({
  formId,
  type,
  year,
  month,
}) {
  const params = new URLSearchParams({
    formId,
    type,
    year,
    ...(month ? { months: month } : {}),
  });
  fetchData(`form/approvalFields?${params.toString()}`)
    .then((res) => res.json())
    .then((res) => {
      if (res.status) {
        this.approvalFieldsRaw = res.data;
      }
    });
};

FormStore.prototype.updateFields = function ({
  data,
  type,
  formId,
  showAlert,
  year,
  month,
}) {
  const { social, governance } = this.rootStore;
  const token = JSON.parse(
    localStorage.getItem("access-token") ||
      localStorage.getItem("admin-access-token")
  )?.token;
  const formData = new FormData();
  formData.append("data", JSON.stringify(data));
  data.forEach((pay) => {  
    if (pay?.attachment?.length) {
      for (let i = 0; i < pay.attachment.length; i++) {
        // Check if the attachment is an actual File object
        if (pay.attachment[i] instanceof File) {
          formData.append(`file[]`, pay.attachment[i]); // Append file
          formData.append(`index[]`, pay.fieldId || i); // Associate with fieldId
        } else {
          console.log(pay.attachment[i], "Skipping, as it's a file path");
        }
      }
    }
  });
  const params = new URLSearchParams({
    type,
    formId,
  });
  fetchData(`form/updateFields?${params.toString()}`, {
    method: "POST",
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .then((res) => {
      showAlert(res.message, res.status);
      if (res.status) {
        if (type === "social") {
          if (month) {
            social.fetch({ year, month });
          } else {
            social.fetch({ year });
          }
        } else if (type === "governance") {
          governance.fetch({ year });
        } else {
          this.fetchApprovalFields({ formId, type, year, month });
        }
      }
    });
};

FormStore.prototype.approveForm = function ({
  type,
  formId,
  showAlert,
  status,
  goback,
  navigate,
  year,
  month,
}) {
  const params = new URLSearchParams({
    type,
    formId,
    status,
    year,
    ...(month ? { months: month } : {}),
  });
  fetchData(`form/formStatus?${params.toString()}`, {
    method: "POST",
  })
    .then((res) => res.json())
    .then((res) => {
      showAlert(res.message, res.status);
      if (res.status) {
        if (type === "social" || type === "governance" || type === "basic") {
          if (goback) {
            navigate(-1);
          } else {
            window.location.reload();
          }
        } else {
          window.location.reload();
        }
      }
    });
};

FormStore.prototype.deleteForm = function ({
  type,
  formId,
  showAlert,
  status,
  goback,
  navigate,
  year,
  month,
}) {
  const params = new URLSearchParams({
    type,
    formId,
    status,
    year,
    ...(month ? { months: month } : {}),
  });
  fetchData(`form/formDelete?${params.toString()}`, {
    method: "POST",
  })
    .then((res) => res.json())
    .then((res) => {
      showAlert(res.message, res.status);
      if (res.status) {
        if (type === "social" || type === "governance" || type === "basic") {
          if (goback) {
            navigate(-1);
          } else {
            window.location.reload();
          }
        } else {
          window.location.reload();
        }
      }
    });
};

FormStore.prototype.logData = function ({ formId }) {
  const params = new URLSearchParams({ formId });
  fetchData(`form/logData?${params.toString()}`, {
    method: "POST",
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.status) {
       
        this.logRaw = res.data;
      }
    });
};

// FormStore.prototype.fetchEnergyByYear = function ({ year, companyUnit, showAlert }) {

//   return new Promise((resolve, reject) => {
//     const token = JSON.parse(
//       localStorage.getItem("access-token") ||
//         localStorage.getItem("admin-access-token")
//     )?.token;

//     this.isLoading = true;
//     this.energyDataByYear = [];

//     fetch(
//       process.env.REACT_APP_BASE_URL +
//         `energy/getDataByYear`,
//       {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ year, companyUnit }),
//       }
//     )
//       .then((res) => res.json())
//       .then((response) => {
//         this.isLoading = false;
//         if (response.success) {
//           this.energyDataByYear = response.data;
//           resolve(response.data);
//           return;
//         }
//         showAlert?.(response.message);
//         reject(new Error(response.message));
//       })
//       .catch((err) => {
//         this.isLoading = false;
//         showAlert?.(err.message);
//         console.error("Error fetching energy data by year:", err);
//         reject(err);
//       });
//   });
// };



FormStore.prototype.fetchEnergyByYear = function ({ year, companyUnit, showAlert }) {
  return new Promise((resolve, reject) => {
    const token = JSON.parse(
      localStorage.getItem("access-token") ||
        localStorage.getItem("admin-access-token")
    )?.token;

    this.isLoading = true;
    this.energyDataByYear = [];

    fetch(
      process.env.REACT_APP_BASE_URL + `energy/getDataByYear`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          year: String(year),        // ← Convert to string here
          companyUnit: Number(companyUnit) // ← Ensure companyUnit is number
        }),
      }
    )
      .then((res) => res.json())
      .then((response) => {
        this.isLoading = false;
        if (response.success) {
          this.energyDataByYear = response.data;
          resolve(response.data);
          return;
        }
        showAlert?.(response.message);
        reject(new Error(response.message));
      })
      .catch((err) => {
        this.isLoading = false;
        showAlert?.(err.message);
        console.error("Error fetching energy data by year:", err);
        reject(err);
      });
  });
};


//below code for financial year
// FormStore.prototype.fetchEnergyByYear = function ({ startYear, endYear, showAlert }) {

//   return new Promise((resolve, reject) => {
//     const token = JSON.parse(
//       localStorage.getItem("access-token") ||
//       localStorage.getItem("admin-access-token")
//     )?.token;

//     this.isLoading = true;
//     this.energyDataByYear = [];

//     fetch(`${process.env.REACT_APP_BASE_URL}energy/getEnergyDataByYear`, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         frequencyYear: [String(startYear), String(endYear)],
//       }),
//     })
//       .then(res => res.json())
//       .then(response => {
//         this.isLoading = false;
//         if (response.success) {
//           this.energyDataByYear = response.data;
//           resolve(response.data);
//           return;
//         }
//         showAlert?.(response.message);
//         reject(new Error(response.message));
//       })
//       .catch(err => {
//         this.isLoading = false;
//         showAlert?.(err.message);
//         console.error("Error fetching energy data by FY:", err);
//         reject(err);
//       });
//   });
// };

// FormStore.prototype.fetchEmissionByYear = function ({ startYear, endYear, showAlert }) {

//   return new Promise((resolve, reject) => {
//     const token = JSON.parse(
//       localStorage.getItem("access-token") || localStorage.getItem("admin-access-token")
//     )?.token;

//     this.isLoading = true;
//     this.emissionDataByYear = [];

//     fetch(`${process.env.REACT_APP_BASE_URL}emission/getEmissionDataByYear`, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         frequencyYear: [String(startYear), String(endYear)],
//       }),
//     })
//       .then(res => res.json())
//       .then(response => {
//         this.isLoading = false;
//         if (response.success) {
//           this.emissionDataByYear = response.data;
//           resolve(response.data);
//         } else {
//           showAlert?.(response.message);
//           reject(new Error(response.message));
//         }
//       })
//       .catch(err => {
//         this.isLoading = false;
//         console.error("Error fetching emission data:", err);
//         showAlert?.(err.message);
//         reject(err);
//       });
//   });
// };

// FormStore.prototype.fetchEmissionByYear = function ({ startYear, endYear, showAlert }) {
  

//   const token = JSON.parse(
//     localStorage.getItem("access-token") || localStorage.getItem("admin-access-token")
//   )?.token;

//   return fetch(`${process.env.REACT_APP_BASE_URL}emission/getEmissionDataByYear`, {
//     method: "POST",
//     headers: {
//       Authorization: `Bearer ${token}`,
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//       frequencyYear: [String(startYear), String(endYear)],
//     }),
//   })
//     .then(res => res.json())
//     .then(response => {
//       if (response.success) {
//         return response.data;
//       } else {
//         showAlert?.(response.message);
//         throw new Error(response.message);
//       }
//     })
//     .catch(err => {
//       console.error("Error fetching emission data:", err);
//       showAlert?.(err.message);
//       throw err;
//     });
// };

FormStore.prototype.fetchEmissionByYear = function ({ year, companyUnit, showAlert }) {
  const token = JSON.parse(
    localStorage.getItem("access-token") || localStorage.getItem("admin-access-token")
  )?.token;

  return fetch(`${process.env.REACT_APP_BASE_URL}emission/getEmissionDataByYear`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      year: String(year),
      companyUnit
    }),
  })
    .then(res => res.json())
    .then(response => {
      if (response.success) {
        return response.data;
      } else {
        showAlert?.(response.message);
        throw new Error(response.message);
      }
    })
    .catch(err => {
      console.error("Error fetching emission data:", err);
      showAlert?.(err.message);
      throw err;
    });
};



FormStore.prototype.fetchBiodiversityByYear = async ({ year, companyUnit, showAlert }) => {
  try {
    const token = JSON.parse(
      localStorage.getItem("access-token") || localStorage.getItem("admin-access-token")
    )?.token;

    const response = await fetch(`${process.env.REACT_APP_BASE_URL}biodiversity/getBiodiversityDataByYear`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ year: String(year), companyUnit }),
    });

    const result = await response.json();

    if (result.success) {
      return result.data;
    } else {
      showAlert?.(result.message || "Failed to fetch biodiversity data");
      return [];
    }
  } catch (error) {
    console.error("Error fetching biodiversity data:", error);
    showAlert?.("Something went wrong while fetching biodiversity data");
    return [];
  }
};

FormStore.prototype.submitTarget = async ({
  companyId,
  unitId,
  kpiId,
  year,
  targetValue,
  showAlert,
}) => {
  try {
    const response = await fetch("/api/target/save", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        companyId,
        unitId,
        kpiId,
        year,
        target: targetValue,
      }),
    });

    const result = await response.json();

    if (result.status) {
      showAlert("Target saved successfully", true);
      return result.data;
    } else {
      showAlert(result.message || "Failed to save target");
    }
  } catch (error) {
    console.error("Error submitting target:", error);
    showAlert("Something went wrong while saving target.");
  }
};
